export default __webpack_public_path__ + "static/media/website.02fba0a2.svg";